import RequestManager from './RequestManager';
import { BASE_PAYMENT_API, PAYMENT_API } from './constants';

export const getPageSettingsData = ({ id }) => {
	return RequestManager.get(`/${BASE_PAYMENT_API}/${PAYMENT_API.PAGE_SETTINGS}/${id}`)
		.then(response=> response?.result);
};

export const getOverviewData = ({ id }) => {
	return RequestManager.get(`/${BASE_PAYMENT_API}/${PAYMENT_API.OVERVIEW}/${id}`)
		.then(response=> response?.result);
};

export const getPaymentResult = ({ id }) => {
	return RequestManager.get(`/${BASE_PAYMENT_API}/${PAYMENT_API.RESULT}/${id}`)
		.then(response=> response?.result);
};

export const doPayment = data => {
	return RequestManager.post(`/${BASE_PAYMENT_API}/${PAYMENT_API.DO_PAYMENT}`, { data })
		.then(response=> response?.result);
};
